import { Controller, useFormContext } from 'react-hook-form'

import { ctrTINTypes } from 'commons/types/dictionaries'
import { FF2, Select, Validators } from 'ui/components'
import { SarEdit } from '~bank-bsa-reporting/types'

import { useSubjectInformationItemContext } from '../SubjectInformationItemContext'

type TINTypeProps = {
  index: number
}

export const TINType = ({ index }: TINTypeProps) => {
  const { control } = useFormContext<SarEdit>()
  const { isAllInfoUnavailable } = useSubjectInformationItemContext()

  return (
    <Controller
      name={`subjectsInfo.${index as 0}.tinType`}
      control={control}
      rules={{
        validate: (value) => (isAllInfoUnavailable ? undefined : Validators.required.field(value))
      }}
      render={({ field }) => (
        <FF2
          required={!isAllInfoUnavailable}
          field={field}
          label="17. TIN type"
          input={(props) => (
            <Select {...props} data={ctrTINTypes} data-qa="17. TIN type" options-data-qa="17. TIN type option" />
          )}
        />
      )}
    />
  )
}
